// Import Three.js, GLTFLoader, and OrbitControls
import * as THREE from './three.module.js';
import { GLTFLoader } from './GLTFLoader.js';
import { OrbitControls } from './OrbitControls.js';
import { RGBELoader } from './RGBELoader.js';
import { PMREMGenerator } from './three.module.js';

const loadedModels = {
  "Basehat": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/Base.glb?v=1705004299",
  "FirstName": null,
  "LastName": null,
  "SchoolName": null,  
  "Kokade": "https://cdn.shopify.com/3d/models/9dfd787597cc0fb6/2_Emblem.glb",
  "CapMat": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/VynalCap.glb?v=1705004299",
  "UpperStrim": null,
  "LowerStrim": null,
  "InsideMat": null,
};  // Object to keep track of loaded models

const FirstNameModelPath = 'https://cdn.shopify.com/s/files/1/0799/3344/0343/files/FNModel.glb?v=1705430769';
const LastNameModelPath = 'https://cdn.shopify.com/s/files/1/0799/3344/0343/files/LNModel.glb?v=1705437671';
const SchoolNameModelPath = 'https://cdn.shopify.com/s/files/1/0799/3344/0343/files/schoolName.glb?v=1705598049';

const kokadePaths = {
  "Classic": "https://cdn.shopify.com/3d/models/9dfd787597cc0fb6/2_Emblem.glb",
  "Diamond": "https://cdn.shopify.com/3d/models/1ce992767ad5280a/DiamondPinv2.glb",
  // Add more as needed
};

const diamondColor = {
  "Navy": 0x0085FF,
  "Gold": 0xFFD700,
  "Crystal": 0xffffff,
  "Green": 0x00b312,
  "Red": 0xc90000,
  "Pink": 0xff75c1,
  // Add more as needed
};

const capPaths = {
  "Vynal": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/VynalCap.glb?v=1705004299",
  "Leather": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/leatherCap.glb?v=1705600893",
  // Add more as needed
};

const insidePaths = {
  "Classic": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/InsideClassic.glb?v=1705009793",
  "Red": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/redinner.glb?v=1705601536",
  "Swe": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/sweinner.glb?v=1705344270",
};

const upperStrimPaths = {
  "GoldStrim": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/newUpperStrim.glb?v=1705600704",
  "SilverStrim": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/SilverUpperStrim.glb?v=1705601035",
};

const lowerStrimPaths = {
  "GoldStrim": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/GoldLowerStrim.glb?v=1705603642",
  "SilverStrim": "https://cdn.shopify.com/s/files/1/0799/3344/0343/files/SilverLowerStrim.glb?v=1705603642",
};

const cameraConfigurations = {
    lookUpFromBelow: {
        position: new THREE.Vector3(0, -0.49497, 0.49497), // A more dramatic angle looking up from below
        lookAt: new THREE.Vector3(0, 0, 0) // Center of the object
    },
    lookFromBack: {
        position: new THREE.Vector3(0, 0, -0.7), // Position behind the object
        lookAt: new THREE.Vector3(0, 0, 0) // Looking towards the front
    },
    lookFromFront: {
        position: new THREE.Vector3(0, 0, 0.7), // Position in front of the object
        lookAt: new THREE.Vector3(0, 0, 0) // Looking towards the center
    },
    lookFromFrontTopRight: {
        position: new THREE.Vector3(0.3, 0.3, 0.6), // Position in front and top-right of the object
        lookAt: new THREE.Vector3(0, 0, 0) // Looking towards the center
    },
    intermediateRight: {
        position: new THREE.Vector3(0.7, 0, 0), // Position on the right side of the object
        lookAt: new THREE.Vector3(0, 0, 0) // Looking towards the center
    },
    intermediateLeft: {
        position: new THREE.Vector3(-0.7, 0, 0), // Position on the left side of the object
        lookAt: new THREE.Vector3(0, 0, 0) // Looking towards the center
    },
};

let SelectedOuterDiamondColor = 0xFFD700
let SelectedInnerDiamondColor = 0x0085FF

let firstNameText = ""; 
let lastNameText =  "";
let schoolNameText =  "";

let controls;
const mobileWidthThreshold = 768; // Width threshold to define a mobile device
let width = 750; 
let height = 625;

let diamondKokard = false

let renderer;
let camera; 
const scene = new THREE.Scene();
const textureLoader = new THREE.TextureLoader();
const embroideryTexture = new Image();

let goldEmbroideryTexture = null;
function loadGoldEmbroideryTexture() {
    const loader = new THREE.TextureLoader();
    loader.crossOrigin = 'anonymous';  // Set cross-origin for CORS compliance
    loader.load(
        'https://cdn.shopify.com/s/files/1/0799/3344/0343/files/Gold_Embroidary.jpg?v=1704546786',
        function (texture) {
            goldEmbroideryTexture = texture;          
        },
        undefined,
        function (error) {
            console.error('Error loading gold embroidery texture:', error);
        }
    );
}
loadGoldEmbroideryTexture();

// Function to initialize the scene and everything in it
function init() {
  if (window.location.pathname.includes('classic-studentmossa')) {return; // Skip everything
    }

  //Take away default product image
  const element = document.getElementById('MediaGallery-template--27477378302295__main');
  if (element) {
      element.remove();
  } else {
      console.log('Element not found');
  }
  
  handleScreenWidth()

  //Logic for container size once in mobile
  const container = document.getElementById('3d-model-container');

  // Camera setup
  const aspectRatio = width / height;
  const narrowFOV = 20; // A smaller FOV to reduce perspective distortion
  camera = new THREE.PerspectiveCamera(narrowFOV, aspectRatio, 0.001, 1000);

  camera.position.set(0, 0, 0.7);
  camera.lookAt(new THREE.Vector3(0, 0, 0));

  // Renderer setup
  renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(width, height);
  renderer.toneMapping = THREE.ACESFilmicToneMapping; // Enable tone mapping
  renderer.toneMappingExposure = 1; // Lower values reduce brightness
  container.appendChild(renderer.domElement);
  renderer.setClearColor(0xffffff); // Set background color

  // Add soft and warm lighting here
  const ambientRed = new THREE.AmbientLight(0xFFD700, 1); // soft white light
  ambientRed.position.set(0, 0, 0.3);
  scene.add(ambientRed);
  
  // Add soft and warm lighting here
  const ambientLight = new THREE.AmbientLight(0xffffff, 1); // soft white light
  ambientLight.position.set(-0.3, 1.5, 0.1);
  scene.add(ambientLight);
  
  const directionalLight = new THREE.DirectionalLight(0xffaa33, 0.7); // warm light
  directionalLight.position.set(0, 1.5, 0.1);
  scene.add(directionalLight);
  
  // Optionally, add a Hemisphere Light for more natural lighting
  const hemiLight = new THREE.HemisphereLight(0xffffbb, 0x080820, 1);
  hemiLight.position.set(-0.3, 1.5, 0.1);
  scene.add(hemiLight);
  
  loadModel(scene, loadedModels.Basehat, "Basehat"); // Load the initial "Basehat" model
  loadModel(scene, loadedModels.CapMat, "CapMat"); // Load the initial "Basehat" model
  loadModel(scene, kokadePaths.Classic, "Kokade");
  loadModel(scene, insidePaths.Classic, "InsideMat");
  loadModel(scene, FirstNameModelPath, "FirstName");
  loadModel(scene, LastNameModelPath, "LastName");
  loadModel(scene, SchoolNameModelPath, "SchoolName");
  
  if (window.location.href.includes('/products/modern-studentmossa')){
    loadModel(scene, upperStrimPaths.GoldStrim, "UpperStrim");
    loadModel(scene, lowerStrimPaths.GoldStrim, "LowerStrim");  
    loadModel(scene, capPaths.Leather, "CapMat"); // Load the initial "Basehat" model
  }

  // Controls setup
  controls = new OrbitControls(camera, renderer.domElement);
  setupControls(controls);

  loadPMREMGenerator(renderer, scene);

  // Animation loop
  function animate() {
    requestAnimationFrame(animate);
    
    // Remove manual scene rotation and let controls handle auto-rotation
    controls.update();
    
    renderer.render(scene, camera);
  }
  animate();

  container.style.width = '350px';
  container.style.height = '600px';
}

function handleScreenWidth() {
    var screenWidth = window.innerWidth;
    if (screenWidth <= mobileWidthThreshold) { 
      console.log(screenWidth)
      width = screenWidth-30;
      height = 250;
    }
}

function loadPMREMGenerator(renderer, scene) {
    // Create a new PMREMGenerator instance
    const pmremGenerator = new PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    // Load the HDR environment map
    const rgbeLoader = new RGBELoader();
    rgbeLoader.load('https://cdn.shopify.com/s/files/1/0799/3344/0343/files/dam_wall_1k.hdr?v=1703366777', function (hdrEquirect) {
        // Use PMREMGenerator to convert HDR Equirectangular to CubeMap
        const envMap = pmremGenerator.fromEquirectangular(hdrEquirect).texture;

        // Apply this environment map for lighting
        scene.environment = envMap;
      
        // Set the scene's background to null for transparency or to a different color/texture
        renderer.toneMappingExposure = 0.8; // Adjust this value as needed
      
        scene.background = new THREE.Color(0xffffff); // Light grey background 0xD3D3D3
      
        // Clean up resources
        pmremGenerator.dispose();
        hdrEquirect.dispose();
    });
}

function loadModel(scene, modelPath, modelId) {
    const loader = new GLTFLoader();
  
    const textureLoader = new THREE.TextureLoader();
    const texture = textureLoader.load(
        'https://cdn.shopify.com/s/files/1/0799/3344/0343/files/diamond.jpg?v=1714898992', 
        function (texture) {
            texture.wrapS = THREE.RepeatWrapping;
            texture.wrapT = THREE.RepeatWrapping;
            texture.repeat.set(4, 4); // Increase the numbers to repeat the texture more times
    
            // Optional: Setting these to repeat the texture can help in controlling the tiling effect
            texture.mapping = THREE.EquirectangularReflectionMapping;
        }
    );
    
    // Use the texture in a material
    const InnerDiamondMaterial = new THREE.MeshPhysicalMaterial({
        color: SelectedInnerDiamondColor,    // White color to mimic diamond
        map: texture, // Use as a regular texture
        envMap: texture, // Use as an environmental reflection map if needed
        metalness: 1,
        roughness: 0,
        transparent: true,
        transmission: 0.2,  // High transmission for transparency effect
        opacity: 1,
        side: THREE.DoubleSide
    });

const OuterDiamondMaterial = new THREE.MeshPhysicalMaterial({
      color: SelectedOuterDiamondColor,    // White color to mimic diamond
      map: texture, // Use as a regular texture
      envMap: texture, // Use as an environmental reflection map if needed
      metalness: 1,
      roughness: 0,
      transparent: true,
      transmission: 0.2,  // High transmission for transparency effect
      opacity: 1,
      side: THREE.DoubleSide
  });
  
    const diamondMaterial = new THREE.MeshPhysicalMaterial({
      color: SelectedOuterDiamondColor,    // White color to mimic diamond
      metalness: 0,       // Set metalness to 0 for non-metallic minerals
      roughness: 0,       // Very smooth surface
      reflectivity: 1.15,    // Max reflectivity for high shine
      clearcoat: 1.15,     // Additional reflective layer
      transmission: 1,  // High transmission for transparency effect
      opacity: 0.99,       // Slightly less than fully opaque
      transparent: true,  // Enable transparency
  });

    loader.load(
        modelPath,
        (gltf) => {
            // Remove existing model if it's already in the scene
            if (loadedModels[modelId]) {
                scene.remove(loadedModels[modelId]);
            }

            // Traverse the loaded model and apply properties
            gltf.scene.traverse((child) => {
                if (child.isMesh && child.material) {
                    // If the model is the unique engraving model
                    if (modelId === 'FirstName' || modelId === 'LastName' || modelId === 'SchoolName') {
                        // Apply engraving properties here
                        applyEngravingToMaterial(child.material, modelId, "");
                    }
                    else if (child.name === "Diamond001") {
                        // Apply the reflective material specifically to the Kokade model
                        child.material = InnerDiamondMaterial;
                    } else if (child.name === "diamond_outer043" || child.name === "diamond_outer042") {
                        // Apply the reflective material to the specific object called diamond_outer.043
                        child.material = OuterDiamondMaterial;
                    }                    
                    else {
                        // Apply any general properties needed for other models
                        // e.g., setting up shadows, adjusting scales, etc.
                        // This part is optional and can be customized or removed as needed.
                    }
                }
            });

            scene.add(gltf.scene);  // Add the GLTF scene to the main scene

            loadedModels[modelId] = gltf.scene;  // Update the reference in loadedModels          
        },
        undefined,  // This function is called while the model is loading (progress callback)
        (error) => {  // This function is called if there's an error during model loading
            console.error(`An error occurred while loading the model (${modelId}):`, error);
        }
    );
}

function refreshModel(scene, modelId, text) {
    const model = loadedModels[modelId];
    if (model) {
        model.traverse((child) => {
            if (child.isMesh && child.material) {
                applyEngravingToMaterial(child.material, modelId, text);
            }
        });
    } else {
        console.error("Model to refresh not found: ", modelId);
    }
}

// Example: Removing a model when a new option is selected
function removeModel(scene, optionName) {
  if (loadedModels[optionName]) {
    scene.remove(loadedModels[optionName]);
    loadedModels[optionName] = null;  // Reset the reference
  }
}

// Function to clear the current model from the scene
function clearScene(scene) {
  while(scene.children.length > 0){ 
    scene.remove(scene.children[0]); 
  }
}

// Setup controls with auto-rotate
function setupControls(controls) {
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.rotateSpeed = 0.5;
  controls.autoRotate = true; // Enable auto-rotate
  controls.autoRotateSpeed = -0.2; // Adjust speed as needed
}

// Function to set up event listeners for model changes
function setupEventListeners() {
  
  //=========================== Spin Check =========================== 
    document.getElementById('3d-model-container').addEventListener('mousedown', function() {
        controls.autoRotate = false;
    });

  document.addEventListener('DOMContentLoaded', function() {
      const spotlightGroup = document.querySelector('.spotlight-group');
      if (spotlightGroup) {
          spotlightGroup.addEventListener('click', function(event) {
              // Check if the click is on a label
              if (event.target.tagName === 'LABEL' && event.target.classList.contains('ymq-options-img-label')) {
                  const color = event.target.getAttribute('data-show');
                  console.log('Label clicked for color:', color);
                  
                  // Since clicking the label will check the associated input, we can fetch the newly selected color value from the checked input
                  setTimeout(() => {
                      const selectedColorInput = document.querySelector('input[name="ymq[Inner Color]"]:checked');
                      const selectedColor = selectedColorInput ? selectedColorInput.value : null;
                      console.log('Newly selected color:', selectedColor);
                      // Update your SelectedDiamondColor variable or perform other actions based on the new color
                      SelectedInnerDiamondColor = diamondColor[selectedColor];
                  }, 0); // Timeout ensures we get the updated checked state
              }
          });
      } else {
          console.log('Spotlight group not found!');
      }
  });


document.addEventListener('DOMContentLoaded', function() {
    const labels = document.querySelectorAll('.ymq-options-img-label');
    labels.forEach(label => {
        label.addEventListener('click', function() {
            const color = this.getAttribute('data-show');
            console.log('Label clicked for color:', color);
            // Execute any logic that needs to happen when a label is clicked
        });
    });
});

  // Attach event listener to the body or a stable parent container
  document.body.addEventListener('click', function(event) {
        const selectedColorInput = document.querySelector('input[name="ymq[Inner Color]"]:checked');
        const selectedColor = selectedColorInput ? selectedColorInput.value : null;
        SelectedInnerDiamondColor = diamondColor[selectedColor]
    
      // Check if the clicked element is the label you're interested in
      if (event.target.classList.contains('ymq-options-img-label')) {
        SelectedInnerDiamondColor = diamondColor[selectedColor]
        // Execute the logic for when this specific label is clicked
      }

  });
  
  //=========================== kokade =========================== 
    document.querySelector('.ymq-multiple-ul').addEventListener('click', (event) => {
    if (event.target && event.target.closest('.ymq-multiple-li')) {
        const selectedLi = event.target.closest('.ymq-multiple-li');
        const selectedOptionText = selectedLi.textContent.trim();
        
        // Fetch the selected color from the radio inputs
//        const selectedColorInput = document.querySelector('input[name="ymq[Inner Color]"]:checked');
//        const selectedColor = selectedColorInput ? selectedColorInput.value : null;
//        SelectedDiamondColor = diamondColor[selectedColor]
//        console.log("Selected option from Kokade list:", selectedOptionText);
//        console.log("Selected color:", selectedColor);
      
        // Load or update the "Kokade" model based on the selection
        if (kokadePaths[selectedOptionText]) {
          loadModel(scene, kokadePaths[selectedOptionText], "Kokade");
          console.log(selectedOptionText);
          diamondKokard = false;
        }
        if (kokadePaths[selectedOptionText]) {
          loadModel(scene, kokadePaths[selectedOptionText], "Diamond");
          diamondKokard = true;
         //loadModel(scene, InnerDiamond["Front"], "FrontDiamond");
          //loadModel(scene, InnerDiamond["Back"], "BackDiamond");

        }
        if (kokadePaths[selectedOptionText]) {
          loadModel(scene, kokadePaths[selectedOptionText], "Leaf");
        }
        if (kokadePaths[selectedOptionText]) {
          loadModel(scene, kokadePaths[selectedOptionText], "Ring");
        }
        else {
          console.log("No Kokade model defined for the selected option:", selectedOptionText);
          // Optionally remove the current "Kokade" model if an undefined option is selected
          if (loadedModels["Kokade"]) {
            console.log("Selected option:", selectedOptionText);
            scene.remove(loadedModels["Kokade"]);
            loadedModels["Kokade"] = null;
          }
        }
      }
      animateCameraToView("lookFromFront");
    });
  
  //=========================== First name engraving text =========================== 
    const firstNameInput = document.getElementById('ymq-attrib-1');
    if (firstNameInput) {
        firstNameInput.addEventListener('input', function(event) {
          animateCameraToView("lookFromFront");
            // Update the engraving text
            firstNameText = event.target.value;

            // Refresh the model to apply the new engraving
            refreshModel(scene, "FirstName", firstNameText);  // Assuming "Basehat" is the model you want to refresh.
        });
    } else {
        console.error("Engraving input element not found!");
    }

  //=========================== Last name engraving text =========================== 
    //Id - ymq-attrib-2
    const lastNameInput = document.getElementById('ymq-attrib-2');
    if (lastNameInput) {
        lastNameInput.addEventListener('input', function(event) {
          animateCameraToView("lookFromFront");
            // Update the engraving text
            lastNameText = event.target.value;

            // Refresh the model to apply the new engraving
            refreshModel(scene, "LastName", lastNameText);  // Assuming "Basehat" is the model you want to refresh.
        });
    } else {
        console.error("Engraving input element not found!");
    }

  
  //=========================== Back side engraving text =========================== 
    //Id - ymq-attrib-3
    const schoolNameInput = document.getElementById('ymq-attrib-3');
    if (schoolNameInput) {
        schoolNameInput.addEventListener('input', function(event) {

            // Update the engraving text
            lastNameText = event.target.value;

            // Refresh the model to apply the new engraving
            refreshModel(scene, "SchoolName", lastNameText);  // Assuming "Basehat" is the model you want to refresh.

        // Animate the camera to the back view if needed
        animateCameraToView("lookFromBack");
          
        });
    } else {
        console.error("Engraving input element not found!");
    }
  
  //=========================== Inside Fabric =========================== 
    //Classic - ymq-options-button-label ymq-attrib-item-7_1
    //Red - ymq-options-button-label ymq-attrib-item-7_2
    //Swe - ymq-options-button-label ymq-attrib-item-7_3
    document.addEventListener('change', function(event) {

        if (event.target.matches('#ymq-attrib-7_1')) {
            loadModel(scene, insidePaths.Classic, "InsideMat"); // Make sure the key is correct
            animateCameraToView("lookUpFromBelow");
        } if (event.target.matches('#ymq-attrib-7_2')) {
            loadModel(scene, insidePaths.Red, "InsideMat"); // Make sure the key is correct
            animateCameraToView("lookUpFromBelow");
        } else if (event.target.matches('#ymq-attrib-7_3')) {
            loadModel(scene, insidePaths.Swe, "InsideMat"); // Make sure the key is correct
            animateCameraToView("lookUpFromBelow");
        }
    });

  
  //=========================== Cap Material =========================== 
    document.addEventListener('change', function(event) {
        if (event.target.matches('#ymq-attrib-6_1')) {
          animateCameraToView("lookFromFrontTopRight");
            loadModel(scene, capPaths.Vynal, "CapMat"); // Make sure the key is correct
        } else if (event.target.matches('#ymq-attrib-6_2')) {
            loadModel(scene, capPaths.Leather, "CapMat"); // Make sure the key is correct
            animateCameraToView("lookFromFrontTopRight");
        }
    });

    //=========================== Top trim =========================== 
    //Option 1 - None 
    //Option 2 - Gold
    //Option 3 - Silver
    const selectElement = document.querySelector('.ymq-attrib-4'); // Replace '.selectElement' with the actual selector of your <select> element
    selectElement.addEventListener('change', function(event) {
        switch (event.target.value) {
            case 'None':
                console.log("None selected");
                scene.remove(loadedModels["UpperStrim"]);
                loadedModels["UpperStrim"] = null;
                break;
            case 'Gold':
                console.log("Gold selected");
                loadModel(scene, upperStrimPaths.GoldStrim, "UpperStrim"); // Replace with your actual logic and model paths
                break;
            case 'Silver':
                console.log("Silver selected");
                loadModel(scene, upperStrimPaths.SilverStrim, "UpperStrim"); // Replace with your actual logic and model paths
                break;
            default:
                //console.log("No valid option selected");
                // Handle no selection or default case
        }
    });

  //=========================== Bottom trim =========================== 
    //Option 1 - None 
    //Option 2 - Gold
    //Option 3 - Silver
    // Assuming your <select> element has a unique ID or class, replace 'selectElement' with the actual selector
    const selectElement2 = document.querySelector('.ymq-attrib-5'); // Replace '.selectElement' with the actual selector of your <select> element
    selectElement2.addEventListener('change', function(event) {
        switch (event.target.value) {
            case 'None':
                console.log("None selected");
                scene.remove(loadedModels["LowerStrim"]);
                loadedModels["LowerStrim"] = null;
                break;
            case 'Gold':
                console.log("Gold selected");
                loadModel(scene, lowerStrimPaths.GoldStrim, "LowerStrim"); // Replace with your actual logic and model paths
                break;
            case 'Silver':
                console.log("Silver selected");
                loadModel(scene, lowerStrimPaths.SilverStrim, "LowerStrim"); // Replace with your actual logic and model paths
                break;
            default:
                console.log("No valid option selected");
                // Handle no selection or default case
        }
    });
}

function setupMutationObserver() {
    const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector('.ymq-multiple-ul');
        if (element) {
            setupEventListeners();  // Call your function to attach event listeners
            obs.disconnect();  // Stop watching for changes
        }
    });

    observer.observe(document, {
        childList: true,  // observe direct children
        subtree: true,    // and lower descendants too
        attributes: false,
        characterData: false,
    });
}

function applyEngravingToMaterial(material, modelId, text) {
  console.log(modelId)
  const uvtexture = createEngravingTexture(modelId, text); // new THREE.TextureLoader().load('https://cdn.shopify.com/s/files/1/0799/3344/0343/files/uv.png?v=1705432333')
  //createEngravingTexture(text); 
  if (modelId == "FirstName"){
    uvtexture.offset.set(-1.45, 0); // Adjust these values to move the texture
    uvtexture.rotation = Math.PI / 2; // Rotate 90 degrees (in radians)  
    uvtexture.center.set(0.5, 0.5);
    uvtexture.repeat.set(0.35, 0.35); // Flip texture across the Y-axis
    material.map = uvtexture; // Apply as a map (color texture)
  }
  if (modelId == "LastName"){
    uvtexture.offset.set(1.45, 0); // Adjust these values to move the texture
    uvtexture.rotation = Math.PI / 2; // Rotate 90 degrees (in radians)  
    uvtexture.center.set(0.5, 0.5);
    uvtexture.repeat.set(-0.35, 0.35); // Flip texture across the Y-axis
    material.map = uvtexture; // Apply as a map (color texture)
  }
  if (modelId == "SchoolName"){
      uvtexture.repeat.y = -Math.abs(uvtexture.repeat.y); // Flip along Y axis
      uvtexture.rotation = Math.PI / 2; // Rotate 90 degrees (in radians)  
      uvtexture.offset.set(-0.35, 0.13); // Adjust these values to move the texture
      material.map = uvtexture; // Apply as a map (color texture)
  }

  material.needsUpdate = true;
  material.transparent = true;
  material.alphaTest = 0.5; // Adjust as needed to handle transparency
}

function createEngravingTexture(modelId, text) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const yaxisPadding = 65;
  
  canvas.width = 1000;
  canvas.height = 1000;

  // Draw the text in a color that will be replaced
  context.font = '150px BallantinesRegular';
  context.fillStyle = 'rgba(0, 0, 0, 1)'; // Fully opaque color

  context.textBaseline = 'middle';

  if (modelId == "FirstName"){
    context.textAlign = 'right';
    context.fillText(text, canvas.width / 2 + 390, canvas.height / 2 - yaxisPadding);
  }
  if (modelId == "LastName"){
    context.textAlign = 'left';
    context.fillText(text, canvas.width / 2 - 380, canvas.height / 2 - yaxisPadding);

  }
  if (modelId == "SchoolName"){
    context.textAlign = 'center';
    context.fillText(text, canvas.width / 2, canvas.height / 2 - yaxisPadding);
  }
  

  // Reset transformation matrix
  context.setTransform(1, 0, 0, 1, 0, 0);

  // Check if the gold embroidery texture is loaded
  if (goldEmbroideryTexture && goldEmbroideryTexture.image) {
    context.globalCompositeOperation = 'source-atop';
    context.drawImage(goldEmbroideryTexture.image, 0, 0, canvas.width, canvas.height);

    // Overlay with semi-transparent black to reduce brightness
    context.fillStyle = 'rgba(0, 0, 0, 0.3)'; // Adjust the last value to control brightness reduction
    context.fillRect(0, 0, canvas.width, canvas.height);  } 
  else {
      console.error('Gold embroidery texture is not loaded yet');
  }

  // Create and return a texture from the canvas
  const texture = new THREE.CanvasTexture(canvas);
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.needsUpdate = true;
  return texture;
}

function animateCameraToView(targetView) {
    const config = cameraConfigurations[targetView];
    const targetPosition = config.position.clone();
    const targetLookAt = config.lookAt.clone();

    const startPosition = camera.position.clone();
    const startLookAt = controls.target.clone();

    const duration = 2000; // Duration of the animation in milliseconds
    let startTime = null;

    // Easing function for smooth transition (easeInOutQuad)
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    function animate(time) {
        if (!startTime) startTime = time;
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1); // Progress from 0 to 1
        const easedProgress = easeInOutQuad(progress); // Apply easing

        // Interpolate camera position and lookAt smoothly using easing
        camera.position.lerpVectors(startPosition, targetPosition, easedProgress);
        controls.target.lerpVectors(startLookAt, targetLookAt, easedProgress);
        controls.update();

        renderer.render(scene, camera);

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else {
            // Ensure camera ends exactly at the target position and orientation
            camera.position.copy(targetPosition);
            controls.target.copy(targetLookAt);
            controls.update();
        }
    }
  
    controls.autoRotate = false;
    requestAnimationFrame(animate);
}

// Handle window resize
window.addEventListener('resize', onWindowResize, false);
function onWindowResize() {
    const newWidth = window.innerWidth;
    const newHeight = window.innerHeight;
    const newAspectRatio = newWidth / newHeight;
    const newCameraWidth = cameraHeight * newAspectRatio;

    camera.left = newCameraWidth / -2;
    camera.right = newCameraWidth / 2;
    camera.top = cameraHeight / 2;
    camera.bottom = cameraHeight / -2;

    camera.updateProjectionMatrix();
    renderer.setSize(newWidth, newHeight);
}


window.addEventListener('scroll', function() {
    // Only execute the logic if the window width is greater than the mobile threshold
    if (window.innerWidth > mobileWidthThreshold && window.location.href.includes('/products/studentmossa')) {
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        const modelContainer = document.getElementById('3d-model-container');
        const endStickPosition = 800; // Y-position in px where the container should stop sticking
        const initialTopPosition = 150; // Adjust this based on your initial design/layout

        if (currentScroll < initialTopPosition) {
            // Reset to initial position
            modelContainer.style.position = 'absolute';
            modelContainer.style.top = `${initialTopPosition}px`;
        } else if (currentScroll > initialTopPosition && currentScroll < endStickPosition) {
            // Follow the scroll
            modelContainer.style.position = 'fixed';
            modelContainer.style.top = '25px';
        } else {
            // Stick to a position when scrolled past endStickPosition
            modelContainer.style.position = 'absolute';
            modelContainer.style.top = `${endStickPosition}px`;
        }
    }
    // If it's a mobile device, the function does nothing
}, false);


// Check if the correct page is loaded and then initialize the script
if (window.location.href.includes('/products/studentmossa')) {
  document.addEventListener('DOMContentLoaded', (event) => {
    setupMutationObserver();  // Start observing for changes as soon as the DOM is ready
    init();
  });
} 
else if (window.location.href.includes('/products/classic-studentmossa') || window.location.href.includes('/products/modern-studentmossa')) {
    init();
}
else {
  console.log('3D model script is loaded on a different page.');
}
